'use strict'

var phones = require('./phones.json')
var countries = require('./countries.json')

export var getMask = function(code = 'CZ') {
  const p = code ? phones[code.toLowerCase()] : null
  return p ? p['example'].replace(/\d/g, '#') : '### ### ###'
}

export var getRegions = function() {
  var regions = []
  countries.map(c => {
    if (!regions.find(r => r.name === c.region)) {
      regions.push({ name: c.region, items: [] })
    }
    regions.find(r => r.name === c.region)['items'].push(c)
  })
  var array = []
  regions.forEach(a => {
    array.push({ name: a.name, active: false })
    array.push(...a.items)
  })
  return array
}

export var getCountry = function(code = 'CZ') {
  return countries.find(c => c.cca2 === code)
}

export var getCountriesWithRegion = function(region) {
  return countries.filter(c => c.region === region)
}

export var getCountries = function(prefered = [], filtered = []) {
  var array = []
  prefered.forEach(p => {
    const country = countries.find(c => c.cca2 === p)
    if (country) {
      array.push(country)
    }
  })
  countries.forEach(c => {
    if ((filtered.length === 0 || filtered.includes(c.cca2)) && (prefered.length === 0 || !prefered.includes(c.cca2))) {
      array.push(c)
    }
  })
  return array
}

// export var langs = function() {
//   return Object.keys(registeredLocales)
// }
